<template>
  <el-dialog
    title="老师添加申请"
    :visible.sync="isShow"
    width="30%"
  >
    <div v-loading="isLoading">
      <div v-if="updateInfo.administrator" class="dialog-item">
        <div class="dialog-item-title accent-color">申请人员：</div>
        <div class="flex-center">
          <v-avatar-nickname
            :value="updateInfo.admin_avatar"
            :nickname="updateInfo.admin_nickname"
            :is-center="false"
          />
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">申请时间：</div>
        <span>{{ updateInfo.add_time | timeToYmdHi }}</span>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">申请门店：</div>
        <span>{{ updateInfo.store_name }}</span>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">老师昵称：</div>
        <div class="flex-center">{{ updateInfo.nickname }}</div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">老师头像：</div>
        <div class="avatar-item">
          <v-avatar class="avatar-item" :value="updateInfo.avatar"></v-avatar>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">手机号：</div>
        <div class="flex-center">{{ updateInfo.phone }}</div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">企业微信号：</div>
        <div class="flex-center">{{ updateInfo.we_chat || '-' }}</div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">微博号：</div>
        <div class="flex-center">{{ updateInfo.micro_blog || '-' }}</div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">美拍号：</div>
        <div class="flex-center">{{ updateInfo.mei_pai || '-' }}</div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">个人简介：</div>
        <div class="flex-center">{{ updateInfo.brief || '-' }}</div>
      </div>

      <div class="dialog-footer">
        <el-button class="footer-button" @click="$emit('back')">返 回</el-button>

        <template v-if="updateInfo.state === updateStates.review.value">
          <template v-if="isAdministrator">
            <el-popover v-model="updateInfo.showRejectTip" placement="top" class="footer-button">
              <p>确认要驳回申请吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" @click="updateInfo.showRejectTip = false">取消</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="$emit('reject', updateInfo)"
                >
                  确认
                </el-button>
              </div>
              <el-button
                :loading="isRejectingIds.includes(updateInfo.id)"
                :disabled="isPassingIds.includes(updateInfo.id)"
                slot="reference"
                type="danger"
              >
                驳回申请
              </el-button>
            </el-popover>

            <el-popover v-model="updateInfo.showPassTip" placement="top">
              <p>确认要通过申请吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" @click="updateInfo.showPassTip = false">取消</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="$emit('pass', updateInfo)"
                >
                  确认
                </el-button>
              </div>
              <el-button
                :loading="isPassingIds.includes(updateInfo.id)"
                :disabled="isRejectingIds.includes(updateInfo.id)"
                slot="reference"
                type="success"
              >
                通过申请
              </el-button>
            </el-popover>
          </template>

          <el-popover
            v-else
            v-model="updateInfo.showRevokeTip"
            placement="top"
          >
            <p>确认要撤销申请吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" @click="updateInfo.showRevokeTip = false">取消</el-button>
              <el-button type="primary" size="mini" @click="handleRevoke">
                确认
              </el-button>
            </div>
            <el-button
              :loading="isRevokingIds.includes(updateInfo.id)"
              slot="reference"
              type="danger"
            >
              撤销申请
            </el-button>
          </el-popover>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import updateStates from '@/enums/cardUpdateStates';

export default {
  props: {
    value: Boolean,
    isLoading: Boolean,
    updateInfo: Object,
    isPassingIds: Array,
    isRejectingIds: Array,
    isRevokingIds: Array,
  },
  watch: {
    value(value) {
      if (value !== this.isShow) this.isShow = value;
    },
    isShow(isShow) {
      if (isShow !== this.value) this.$emit('input');
    },
  },
  data: () => ({
    isShow: false,
    updateStates,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    handleRevoke() {
      this.updateInfo.showRevokeTip = false;
      this.$emit('revoke', this.updateInfo);
    },
  }
};
</script>

<style src="./index.css" scoped/>
